export default __webpack_public_path__ + "media/images/images_v2/bordure-action1-0384c28015faad22313be5bcf305c787.png";